import { Route, Routes } from 'react-router-dom';
import './App.css';
import 'antd-css-utilities/utility.min.css';
import Main from './Components/Layout/Main';
import Login from './Components/Auth/Login';
import Forum from './Components/Layout/Pages/Forum/Forum';
import Dashboard from './Components/Layout/Pages/Dashboard';
import Directory from './Components/Layout/Pages/Approval/Directory';
import MemberDetails from './Components/Layout/Pages/Approval/MemberDetails';
import EventDashboard from './Components/Layout/Pages/Events/EventDashboard';
import Event from './Components/Layout/Pages/Events/Events';
import EventDetails from './Components/Layout/Pages/Events/EventDetails';
import Category from './Components/Layout/Pages/Master/Category';
import ForumDetails from './Components/Layout/Pages/Forum/ForumDetails';
import UserReports from './Components/Layout/Pages/Approval/UserReports';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import Sponsor from './Components/Layout/Pages/Master/Sponsor';
import ChangePassword from './Components/Auth/ChangePassword';
import News from './Components/Layout/Pages/News/News';
import Donation from './Components/Layout/Pages/Donation/Donation';
import Charity from './Components/Layout/Pages/Charity/Charity';
import DonationDetails from './Components/Layout/Pages/Donation/DonationDetails';
import NewsDetails from './Components/Layout/Pages/News/NewsDetails';
import CharityDetails from './Components/Layout/Pages/Charity/CharityDetails';
import MarketPlace from './Components/Layout/Pages/MarketPlace/MarketPlace';
import VendorDiscount from './Components/Layout/Pages/VendorDiscount/VendorDiscount';
import VendorDetails from './Components/Layout/Pages/VendorDiscount/VendorDetails';
import MarketDetails from './Components/Layout/Pages/MarketPlace/MarketDetails';
import Master from './Components/Layout/Pages/AddMaster/Master';
import MasterDetails from './Components/Layout/Pages/AddMaster/MasterDetails';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/changePassword" element={
          <ChangePassword />} />
        <Route path="/main/*" element={
          <ProtectedRoute>
            <Main />
          </ProtectedRoute>
        }>
          {/* <Route path="dashboard" element={<Dashboard />} /> */}

          <Route path="directory">
            <Route index element={
              <ProtectedRoute>
                <Directory />
              </ProtectedRoute>
            } />
            <Route path="member/:id" element={
              <ProtectedRoute>
                <MemberDetails />
              </ProtectedRoute>
            } />
          </Route>
          <Route path="userreports" element={
            <ProtectedRoute>
              <UserReports />
            </ProtectedRoute>
          } />
          <Route path="master" element={
            <ProtectedRoute>
              <Category />
            </ProtectedRoute>
          } />
          <Route path="sponsor" element={
            <ProtectedRoute>
              <Sponsor />
            </ProtectedRoute>
          } />
          <Route path="news">

            <Route index element={
              <ProtectedRoute>
                <News />
              </ProtectedRoute>
            } />
            <Route path="news/:id" element={
              <ProtectedRoute>
                <NewsDetails />
              </ProtectedRoute>
            } />
          </Route>
          <Route path="donation">
            <Route index element={
              <ProtectedRoute>
                <Donation />
              </ProtectedRoute>
            } />
            <Route path="donation/:id" element={
              <ProtectedRoute>
                <DonationDetails />
              </ProtectedRoute>
            } />
          </Route>
          <Route path="charity">

            <Route index element={
              <ProtectedRoute>
                <Charity />
              </ProtectedRoute>
            } />
            <Route path="charity/:id" element={
              <ProtectedRoute>
                <CharityDetails />
              </ProtectedRoute>
            } />
          </Route>
          <Route path="events">
            <Route index element={
              <ProtectedRoute>
                <EventDashboard />
              </ProtectedRoute>
            } />
            <Route path="event/:id" element={
              <ProtectedRoute>
                <EventDetails />
              </ProtectedRoute>
            } />
          </Route>
           <Route path="addmaster">
            <Route index element={
              <ProtectedRoute>
                <Master />
              </ProtectedRoute>
            } />
            <Route path="addmaster/:id" element={
              <ProtectedRoute>
                <MasterDetails />
              </ProtectedRoute>
            } />
          </Route>
          <Route path="marketplace" >
            <Route index element={
              <ProtectedRoute>
                <MarketPlace />
              </ProtectedRoute>
            } />
            <Route path="marketplace/:id" element={
              <ProtectedRoute>
                <MarketDetails />
              </ProtectedRoute>
            } />
          </Route>
          <Route path="vendordiscount">
            <Route index element={
              <ProtectedRoute>
                <VendorDiscount />
              </ProtectedRoute>
            } />

            <Route path="vendordiscount/:id" element={
              <ProtectedRoute>
                <VendorDetails />
              </ProtectedRoute>
            } />
          </Route>
          {/* <Route path="eventDetails" element={<Event />} /> */}
          <Route path="forum"  >
            <Route index element={
              <ProtectedRoute>
                <Forum />
              </ProtectedRoute>
            } />
            <Route path="forum/:id" element={
              <ProtectedRoute>
                <ForumDetails />
              </ProtectedRoute>
            } />
          </Route>
          
        </Route>
      </Routes>
    </>
  );
}

export default App;
